import React from 'react'
import { connect } from 'react-redux'
import StartupMessageBanner from 'components/StartupMessageBanner'
import { dismissStartupMessage } from 'actions/visits'

function StartupMessageBannerContainer(props) {
  const {
    startupMessage,
    dismissStartupMessage
  } = props

  if (!startupMessage) {
    return null
  }

  return (
    <StartupMessageBanner
      message={startupMessage.text}
      duration={startupMessage.duration}
      persistent={startupMessage.persistent}
      onDismiss={dismissStartupMessage}
    />
  )
}

function mapStateToProps(state) {
  return {
    startupMessage: state.visit.startupMessage
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dismissStartupMessage: () => dispatch(dismissStartupMessage())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(StartupMessageBannerContainer)

